module.exports = __webpack_public_path__ + "static/img/twxcode.374c5d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/twxcode.png
// module id = 6ozt
// module chunks = 1